import AMapLoader from '@amap/amap-jsapi-loader';

window._AMapSecurityConfig = {
    securityJsCode: "b088ce075eb5319e5a52a5319e76adc1",
};

const AMap = async () => {
    try {
        const AMapInstance = await AMapLoader.load({
            key: "d4b12fc2d4f5414ef687df228bd8ad6b",
            version: "2.0",
            "AMapUI": {
                "version": '1.1',
                "plugins":[],
            },
            plugins: [
                "Map3D,ElasticMarker,AMap.DistrictSearch,AMap.OverView,AMap.ToolBar,AMap.MapType,AMap.Map",
            ],
        });
        return AMapInstance;
    } catch (error) {
        throw new Error('Error loading AMap: ' + error);
    }
};

export { AMap };
